import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, addDoc, updateDoc, deleteDoc, doc, getDoc, setDoc, increment, query, orderBy } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB15tA_QgpTFxPZwY6KYer3-qkNy8O9toI",
  authDomain: "my-portfolio-ab70c.firebaseapp.com",
  projectId: "my-portfolio-ab70c",
  storageBucket: "my-portfolio-ab70c.firebasestorage.app",
  messagingSenderId: "252303201016",
  appId: "1:252303201016:web:d34cd12964d81ddbd6e10d",
  measurementId: "G-SSVXZC3V25"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Export everything needed
export { 
  db, 
  auth, 
  analytics,
  storage,
  collection, 
  getDocs, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  doc, 
  getDoc, 
  setDoc, 
  increment,
  query,
  orderBy,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll
};